import { useCallback } from 'react'

import { ConversationStreamStatuses } from '../../../../hooks/useConversationStream'
import { useCatalogItemCartContext } from '../../../../providers/CatalogItemCartProvider'
import { useConversation } from '../../../../providers/ConversationProvider'
import { type ConversationTelemetryEvent } from '../../../../value-objects/ConversationTelemetryEvent'
import {
  type ConversationCatalogItemComponent,
  type ConversationChoiceOption,
  type ConversationTurnItem,
} from '../../../../value-objects/ConversationTurnItem'

interface IUseRunConversationTurnPresenterResult {
  data: {
    items: ConversationTurnItem[]
    telemetry: ConversationTelemetryEvent[]
  }
  states: {
    isStreaming: boolean
    thinkingLabel: Nullable<string>
    selectedCatalogItemId: Nullable<string>
  }
  commands: {
    selectChoice: (option: ConversationChoiceOption) => void
    sendMessage: (message: string) => boolean
    selectCatalogItem: (item: ConversationCatalogItemComponent) => void
  }
}

export const useRunConversationTurnPresenter =
  (): IUseRunConversationTurnPresenterResult => {
    const { items, status, thinkingLabel, telemetry, sendMessage } =
      useConversation()
    const { selectCatalogItem, selectedItem } = useCatalogItemCartContext()

    const selectChoice = useCallback(
      (option: ConversationChoiceOption) => sendMessage(option.message),
      [sendMessage]
    )

    return {
      data: { items, telemetry },
      states: {
        isStreaming: status === ConversationStreamStatuses.STREAMING,
        thinkingLabel,
        selectedCatalogItemId: selectedItem?.itemId ?? null,
      },
      commands: { selectChoice, sendMessage, selectCatalogItem },
    }
  }
